export default {
  spanStyle:
    'text-black text-opacity-60 px-3 py-2 font-roboto text-sm font-normal leading-3 tracking-wider',
  personIconStyle: 'text-[#016fa1ff] mr-1 w-[16px]! h-[16px]!',
  disabledPersonIconStyle: 'text-[#000000] opacity-40 mr-2',
  menuItem: 'p-0! bg-white mx-0! my-2!',
  typographyStyle: 'body1',
  rowStyle: 'flex items-center',
  typeBoxStyle:
    'h-full flex items-center border-l-2 border-l-gray-500 justify-center pl-2',
  groupsStyle: ' bg-white rounded-[15px] text-[12px] py-1 px-2',
  contactTitleText: 'inline-block text-black text-opacity-60 text-xs pb-2',
  divider: 'm-0',
  paperClass: 'bg-[#FFD190]! mb-[8px]! p-[10px]!',
  roundText:
    'w-10 h-10 rounded-full bg-[#016fa1ff] flex justify-center items-center p-5',
  roundTextCircle: 'text-white text-[20px]',
  accountStyle: 'flex justify-between items-center w-[350px]!',
};
